var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "nav nav-tabs cf-panel-tab-header cf-panel-lg" },
        [
          _c(
            "li",
            {
              class: { active: _vm.activeForm === "search" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeForm = "search"
                },
              },
            },
            [
              _c("a", { attrs: { href: "#form-search" } }, [
                _vm._v(_vm._s(_vm.$t("queryForm.search"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.activeForm === "explore" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeForm = "explore"
                },
              },
            },
            [
              _c("a", { attrs: { href: "#form-explore" } }, [
                _vm._v(_vm._s(_vm.$t("queryForm.explore"))),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "tab-content cf-panel-tab-body cf-panel-lg clearfix",
          staticStyle: { "padding-top": "0" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.submit.apply(null, arguments)
            },
            reset: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.reset.apply(null, arguments)
            },
          },
        },
        [
          _c("QueryFormSearch", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeForm === "search",
                expression: "activeForm === 'search'",
              },
            ],
            class: {
              "col-xs-12": true,
              "col-md-6": _vm.filtersVisible && !_vm.queryBuilderVisible,
            },
            attrs: { id: "form-search" },
          }),
          _vm._v(" "),
          _c("QueryFormExplore", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeForm === "explore",
                expression: "activeForm === 'explore'",
              },
            ],
            class: {
              "col-xs-12": true,
            },
            attrs: { id: "form-explore" },
          }),
          _vm._v(" "),
          _vm.filtersVisible
            ? _c(
                "div",
                {
                  class: {
                    "col-xs-12": true,
                    "visible-xs": true,
                    "visible-sm": true,
                    "visible-md":
                      _vm.queryBuilderVisible || _vm.activeForm === "explore",
                    "visible-lg":
                      _vm.queryBuilderVisible || _vm.activeForm === "explore",
                  },
                },
                [_c("hr")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("QueryFormFilters", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.filtersVisible,
                expression: "filtersVisible",
              },
            ],
            class: {
              "col-xs-12": true,
              "col-md-6":
                _vm.activeForm === "search" && !_vm.queryBuilderVisible,
              "col-md-9":
                _vm.activeForm === "explore" || _vm.queryBuilderVisible,
            },
            attrs: { id: "filtercontainer" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12" }, [
            _c("hr"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg",
                attrs: { type: "submit" },
              },
              [_vm._v(_vm._s(_vm.$t("queryForm.search")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-lg",
                attrs: { type: "reset", title: "Start a new search" },
              },
              [_vm._v(_vm._s(_vm.$t("queryForm.reset")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-default",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.historyOpen = true
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("queryForm.history")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-default",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.settingsOpen = true
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "glyphicon glyphicon-cog",
                  staticStyle: { "vertical-align": "text-top" },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.settingsOpen
        ? _c("QueryFormSettings", {
            attrs: { id: "settings" },
            on: {
              close: function ($event) {
                _vm.settingsOpen = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.historyOpen
        ? _c("History", {
            attrs: { id: "history" },
            on: {
              close: function ($event) {
                _vm.historyOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }